// components/charts/DockChart.component.jsx
import React, { useState, useEffect, useMemo } from "react";
import "./MyChart.styles.scss";
import BarChart from "./BarChart";
import LineChart from "./LineChart";
import PieChart from "./PieChart";
import { UserData } from "./Data";

import { useLocation } from "react-router-dom";

import {
  getStartOfDay,
  getEndOfDay,
  getStartOfWeek,
  getEndOfWeek,
  getStartOfMonth,
  getEndOfMonth,
  secondsToHM,
} from "../../utils/dateUtils";

// import ChartDataLabels from "chartjs-plugin-datalabels";

import Avatar from "../retro/avatar/avatar.component";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {
  IoChevronBackOutline,
  IoChevronForwardOutline,
  IoPieChart,
  IoPieChartOutline,
  IoBarChart,
  IoBarChartOutline,
  IoChevronUp,
} from "react-icons/io5";
import { BsHourglassSplit } from "react-icons/bs";

import { db } from "../../firebase/firebase.utils";

import { useSelector } from "react-redux";

import { setStationData } from "../../redux/space/space.actions";

function DockChart({ activeSpaceData, display="flex" }) {
  const currentUser = useSelector((state) => state.user.currentUser);
  const users = useSelector((state) => state.user.users);
  const stationData = useSelector((state) => state.space.stationData);
  const location = useLocation();
  const currentSpaceId = location.pathname.split("/")[2];
  const [activeTab, setActiveTab] = useState("day");
  const [activeChart, setActiveChart] = useState("pie");
  const [userTimeLogs, setUserTimelogs] = useState([]);
  let todayref = new Date();
  const [queryStart, setQueryStart] = useState(getStartOfDay(todayref));
  const [queryEnd, setQueryEnd] = useState(getEndOfDay(todayref));

  const [pickerDate, setPickerDate] = useState(new Date());

  // const [assignedTasks, setAssignedTasks] = useState([]);
  const [activeBtn, setActiveBtn] = useState("Month");

  const [memberData, setMemberData] = useState([]);
  const [selectUserOpen, setSelectUserOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(currentUser);

  const timelogsRef = db
    .collection("users")
    .doc(selectedUser.uid)
    .collection("timelogs");

  useEffect(() => {
    const unsub = timelogsRef
      .where("logTime", "<=", queryEnd)
      .where("logTime", ">", queryStart)
      .onSnapshot((collection) => {
        let logs = [];
        collection.forEach((doc) => {
          logs.push({ ...doc.data(), id: doc.id });
        });
        setUserTimelogs(logs);
      });
    return () => {
      unsub();
    };
  }, [queryStart, queryEnd, selectedUser]);

  useEffect(() => {
    if (!users) return;
    if (activeSpaceData) {
      const { members } = activeSpaceData;
      let workspacemembers = [];
      workspacemembers = members.map((memberId) => {
        const memberFind = users.filter((item) => item.uid === memberId);
        return memberFind[0];
      });
      // let reflist = [];
      // if (project.members) {
      // stationData.forEach((project) => reflist.push(...project.members));
      // }
      // const projectmembs = users.filter((user) => reflist.includes(user.uid));
      // setMemberData(membs);
      // // console.log("ALLMEMBS", membs);
      setMemberData([...workspacemembers]);
    }
  }, [activeSpaceData, users]);

  const [userData, setUserData] = useState({
    labels: stationData.map((data) => data.name),
    emojis: stationData.map((data) => data.emojicon),
    datasets: [
      {
        label: "Worked Hours",
        data: UserData.map((data) => data.hours),
        backgroundColor: "#3b3b3b",
        hoverOffset: 4,
        // emojis: stationData.map((data) => data.emojicon),
        // backgroundColor: UserData.map((data) => data.color),
        // backgroundColor: [
        //     "rgba(75,192,192,1)",
        //     "#ecf0f1",
        //     "#50AF95",
        //     "#f3ba2f",
        //     "#2a71d0",
        //     "#2a71d0",
        // ],
        // borderColor: "black",
        // borderWidth: 2,
      },
    ],
  });

  // const options = {
  //   maintainAspectRatio: false,
  //   legend: {
  //     display: true,
  //     position: "left",
  //   },
  //   layout: {
  //     padding: 4,
  //   },
  // };

  const options = {
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    layout: {
      padding: 4,
    },
    plugins: {
      datalabels: {
        render: "image",
        display: true,
        formatter: function (value, context) {
          // return context.chart.data[context.dataIndex];
          if (value === 0 || null) {
            return;
          }
          return secondsToHM(value);
        },
        color: "#404040",
        backgroundColor: "#fff",
      },
      tooltip: {
        callbacks: {
          title: function (tooltipItem, data) {
            return `${tooltipItem[0].label} Workspace`;
          },
          label: function (context, data) {
            let label = context.dataset.label || "";
            let convertedVal = secondsToHM(
              context.dataset.data[context.dataIndex]
            );
            return `${label}: ${convertedVal}`;
          },
        },
      },
    },
  };

  function calculateSum(array, property) {
    let sum = 0;

    array.forEach((element) => {
      sum += element[property];
    });

    return sum;
  }

  function shadeColor(color, percent) {
    var R = parseInt(color.substring(1, 3), 16);
    var G = parseInt(color.substring(3, 5), 16);
    var B = parseInt(color.substring(5, 7), 16);

    R = parseInt((R * (100 + percent)) / 100);
    G = parseInt((G * (100 + percent)) / 100);
    B = parseInt((B * (100 + percent)) / 100);

    R = R < 255 ? R : 255;
    G = G < 255 ? G : 255;
    B = B < 255 ? B : 255;

    R = Math.round(R);
    G = Math.round(G);
    B = Math.round(B);

    var RR = R.toString(16).length == 1 ? "0" + R.toString(16) : R.toString(16);
    var GG = G.toString(16).length == 1 ? "0" + G.toString(16) : G.toString(16);
    var BB = B.toString(16).length == 1 ? "0" + B.toString(16) : B.toString(16);

    return "#" + RR + GG + BB;
  }

  useMemo(() => {
    const pluss = stationData.map((station) =>
      calculateSum(
        userTimeLogs.filter((t) => t.fromStationId === station.stationId),
        "duration"
      )
    );
    setUserData({
      labels: stationData.map((data) => data.name),
      datasets: [
        {
          label: "Worked on",
          data: pluss,
          backgroundColor: [
            activeSpaceData.color,
            shadeColor(activeSpaceData.color, 10),
            shadeColor(activeSpaceData.color, -10),
          ],
          // backgroundColor: [
          //     "rgba(75,192,192,1)",
          //     "#ecf0f1",
          //     "#50AF95",
          //     "#f3ba2f",
          //     "#2a71d0",
          //     "#2a71d0",
          // ],
          // borderColor: "#3b3b3b",
          // borderWidth: 2,
          hoverOffset: 4,
        },
      ],
    });
  }, [userTimeLogs]);

  const handleChangeTab = (e) => {
    if (e.target.value === "day") {
      handleDaySelect(new Date());
    } else if (e.target.value === "week") {
      handleWeekSelect(new Date());
    } else if (e.target.value === "month") {
      handleMonthSelect(new Date());
    }
    setActiveTab(e.target.value);
  };

  const handleDaySelect = (date) => {
    setPickerDate(date);
    const qstart = getStartOfDay(date);
    const qend = getEndOfDay(date);
    setQueryStart(qstart);
    setQueryEnd(qend);
  };

  const handleWeekSelect = (date) => {
    setPickerDate(date);
    const qstart = getStartOfWeek(date);
    const qend = getEndOfWeek(date);
    setQueryStart(qstart);
    setQueryEnd(qend);
  };

  const handleMonthSelect = (date) => {
    setPickerDate(date);
    const qstart = getStartOfMonth(date);
    const qend = getEndOfMonth(date);
    setQueryStart(qstart);
    setQueryEnd(qend);
  };

  return (
    <div className="custom__chart" style={{display: display}}>
      {/* <div style={{ width: 200 }}>
                <BarChart chartData={userData} />
            </div>
            <div style={{ width: 200 }}>
                <LineChart chartData={userData} />
            </div> */}
      <div className="chart__settings-top">
        <div className="chart__switch">
          <button
            className={
              activeChart === "pie" ? "chart-btn" : "chart-btn-passive"
            }
            onClick={() => setActiveChart("pie")}
          >
            {activeChart === "pie" ? <IoPieChart /> : <IoPieChartOutline />}
          </button>
          <button
            className={
              activeChart === "bar" ? "chart-btn" : "chart-btn-passive"
            }
            onClick={() => setActiveChart("bar")}
          >
            {activeChart === "bar" ? <IoBarChart /> : <IoBarChartOutline />}
          </button>
        </div>
        <select onChange={handleChangeTab}>
          <option value="day">Daily</option>
          <option value="week">Weekly</option>
          <option value="month">Monthly</option>
        </select>
      </div>
      <div
        className="custom__chart-graph"
        style={{ width: "100%", heigh: "100%" }}
      >
        {userTimeLogs.length > 0 ? (
          <>
            {activeChart === "pie" ? (
              <PieChart chartData={userData} options={options} />
            ) : (
              <BarChart chartData={userData} />
            )}
          </>
        ) : (
          <div className="custom__chart-graph-nodata">
            <h4>No tracked time found for the selected period.</h4>
            <BsHourglassSplit size="5em" />
          </div>
        )}
      </div>
      <div className="chart__settings-bottom">
        <div
          className="chart_user-avatar"
          onClick={() => setSelectUserOpen(!selectUserOpen)}
        >
          {/* <div className="avatar">
            <img src={selectedUser?.imageUrl} />
          </div> */}
          <Avatar src={selectedUser?.imageUrl} user={selectedUser} />
          <div className="chart_username">
            <p>{selectedUser?.userName}</p>
            <IoChevronUp />
          </div>
        </div>
        {selectUserOpen && (
          <div className="ch__selectperson">
            {memberData.map((member) => {
              return (
                <button
                  key={member.uid}
                  member={member}
                  image={member.imageUrl}
                  // activeSpaceData={activeSpaceData}
                  // activeSpaceId={activeSpaceId}
                  className="ch__selectperson_item"
                  onClick={() =>
                    setSelectedUser(member) & setSelectUserOpen(false)
                  }
                >
                  <Avatar src={member.imageUrl} user={member} />
                  {member.userName}
                </button>
              );
            })}
          </div>
        )}
        {activeTab === "day" && (
          <div className="chart__btn-group">
            <div className="chart__btn-group-nav">
              <button
                onClick={() => handleDaySelect(new Date(pickerDate - 86400000))}
              >
                <IoChevronBackOutline />
              </button>
              <button className="chart__datepicker-day">
                <DatePicker
                  popperProps={{ strategy: "fixed" }}
                  wrapperClassName="chart__datepicker-wrp"
                  // isClearable
                  placeholderText="..."
                  value={pickerDate}
                  // showTimeSelect
                  dateFormat="MMMM dd"
                  selected={pickerDate}
                  maxDate={new Date()}
                  onChange={(date) => handleDaySelect(date)}
                />
              </button>
              <button
                onClick={() =>
                  handleDaySelect(
                    new Date(pickerDate.setDate(pickerDate.getDate() + 1))
                  )
                }
              >
                <IoChevronForwardOutline />
              </button>
            </div>
            <button
              onClick={() => handleDaySelect(new Date())}
              className={
                pickerDate.toDateString() === new Date().toDateString()
                  ? "journal__today-btn"
                  : "journal__today-btn-passive"
              }
            >
              Today
            </button>
          </div>
        )}
        {activeTab === "week" && (
          <div className="chart__btn-group">
            <div className="chart__btn-group-nav">
              <button
                onClick={() =>
                  handleWeekSelect(
                    new Date(pickerDate - 7 * 24 * 60 * 60 * 1000)
                  )
                }
              >
                <IoChevronBackOutline />
              </button>
              <button className="chart__datepicker-week">
                <DatePicker
                  popperProps={{ strategy: "fixed" }}
                  wrapperClassName="chart__datepicker-wrp"
                  // isClearable
                  placeholderText="..."
                  value={`${getStartOfWeek(pickerDate).toLocaleDateString(
                    undefined,
                    { month: "short", day: "numeric" }
                  )} - ${getEndOfWeek(pickerDate).toLocaleDateString(
                    undefined,
                    {
                      month: "short",
                      day: "numeric",
                    }
                  )}`}
                  // showTimeSelect
                  dateFormat="dd"
                  selected={pickerDate}
                  maxDate={new Date()}
                  showWeekNumbers
                  startDate={getStartOfWeek(pickerDate)}
                  endDate={getEndOfWeek(pickerDate)}
                  // showMonthYearPicker
                  onChange={(date) => handleWeekSelect(date)}
                />
              </button>
              <button
                onClick={() =>
                  handleWeekSelect(
                    new Date(pickerDate.setDate(pickerDate.getDate() + 7))
                  )
                }
              >
                <IoChevronForwardOutline />
              </button>
            </div>
            <button
              onClick={() => handleWeekSelect(new Date())}
              className={
                getStartOfWeek(pickerDate).toDateString() ===
                getStartOfWeek(new Date()).toDateString()
                  ? "journal__today-btn"
                  : "journal__today-btn-passive"
              }
            >
              This Week
            </button>
          </div>
        )}
        {activeTab === "month" && (
          <div className="chart__btn-group">
            <div className="chart__btn-group-nav">
              <button
                onClick={() =>
                  handleMonthSelect(
                    new Date(pickerDate.setMonth(pickerDate.getMonth() - 1))
                  )
                }
              >
                <IoChevronBackOutline />
              </button>
              <button className="chart__datepicker-month">
                <DatePicker
                  popperProps={{ strategy: "fixed" }}
                  wrapperClassName="chart__datepicker-wrp"
                  // isClearable
                  placeholderText="..."
                  value={pickerDate}
                  // showTimeSelect
                  dateFormat="MMMM, yyyy"
                  selected={pickerDate}
                  maxDate={new Date()}
                  showMonthYearPicker
                  onChange={(date) => handleMonthSelect(date)}
                />
              </button>
              <button
                onClick={() =>
                  handleMonthSelect(
                    new Date(pickerDate.setMonth(pickerDate.getMonth() + 1))
                  )
                }
              >
                <IoChevronForwardOutline />
              </button>
            </div>
            <button
              onClick={() => handleMonthSelect(new Date())}
              className={
                pickerDate.toDateString() === new Date().toDateString()
                  ? "journal__today-btn"
                  : "journal__today-btn-passive"
              }
            >
              This Month
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default DockChart;
